import { PeerPoolItem, PeerAttributes, StakeInfo } from './../api/types';
import { GovernanceApi } from '../api/governance';
import { Rpc } from '../rpc/rpc';

export class GovernanceApiImp implements GovernanceApi {
  private rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
  }

  registerCandidate(args: {
    peerPubKey: string,
    amount: string,
    gasPrice?: string,
    gasLimit?: string
  }) {
    return this.rpc.call<string>('governance.registerCandidate', args);
  }

  addInitPos(args: {
    peerPubKey: string,
    amount: string,
    gasPrice?: string,
    gasLimit?: string
  }) {
    return this.rpc.call<string>('governance.addInitPos', args);
  }

  reduceInitPos(args: {
    peerPubKey: string,
    amount: string,
    gasPrice?: string,
    gasLimit?: string
  }) {
    return this.rpc.call<string>('governance.reduceInitPos', args);
  }

  stakePeers(args: {
    peerPubKeys: string[],
    amounts: string[],
    gasPrice?: string,
    gasLimit?: string
  }) {
    return this.rpc.call<string>('governance.stakePeers', args);
  }

  redeemPeers(args: {
    peerPubKeys: string[],
    amounts: string[],
    gasPrice?: string,
    gasLimit?: string
  }) {
    return this.rpc.call<string>('governance.redeemPeers', args);
  }

  withdrawFeeReward(args: { gasPrice?: string, gasLimit?: string }) {
    return this.rpc.call<string>('governance.withdrawFeeReward', args);
  }

  withdrawUnfrozenOnt(args: {
    peerPubKeys: string[],
    amounts: string[],
    gasPrice?: string,
    gasLimit?: string
  }) {
    return this.rpc.call<string>('governance.withdrawUnfrozenOnt', args);
  }

  withdrawPeerUnboundOng(args: { gasPrice?: string, gasLimit?: string }) {
    return this.rpc.call<string>('governance.withdrawPeerUnboundOng', args);
  }

  setFeePercentage(args: {
    peerPubKey: string,
    peerCost: number,
    stakeCost: number,
    gasPrice?: string,
    gasLimit?: string
  }) {
    return this.rpc.call<string>('governance.setFeePercentage', args);
  }

  changeMaxAuthorization(args: {
    peerPubKey: string,
    maxAuthorize: string,
    gasPrice?: string,
    gasLimit?: string
  }) {
    return this.rpc.call<string>('governance.changeMaxAuthorization', args);
  }

  quitNode(args: { peerPubKey: string, gasPrice?: string, gasLimit?: string }) {
    return this.rpc.call<string>('governance.quitNode', args);
  }

  getAllPeerPool() {
    return this.rpc.call<PeerPoolItem[]>('governance.getAllPeerPool');
  }

  getAttributes(args: { peerPubKey: string }) {
    return this.rpc.call<PeerAttributes>('governance.getAttributes', args);
  }

  getStakeInfo(args: { peerPubKey: string }) {
    return this.rpc.call<StakeInfo>('governance.getStakeInfo', args);
  }

  getRewardFeeAmount() {
    return this.rpc.call<string>('governance.getRewardFeeAmount');
  }
}
